import React, { FunctionComponent } from "react";
import PageLayout from "@components/layouts/PageLayout";
import { RouteComponentProps } from "react-router";
import { HOME_MENU } from "@utils/enums/home.enum";
import HomeCard from "@components/cards/HomeCard";
import BasicDivider from "@components/divider/BasicDivider";

const HomeScreen: FunctionComponent<RouteComponentProps> = () => {
  return (
    <PageLayout
      container={false}
      noContentInCard
      bodyClassName="app-home-screen"
      noFooter={false}
    >
      <>
        <div className="d-flex align-items-center justify-content-center justify-content-md-around flex-column flex-md-row h-100">
          {HOME_MENU.map((item, index) => (
            <React.Fragment key={item.key}>
              {index > 0 && (
                <>
                  <BasicDivider
                    variant="grey"
                    className="home-screen-divider mt-0 mb-0"
                  />
                </>
              )}
              <HomeCard
                key={item.key}
                link={item.link}
                icon={item.icon}
                iconMobile={item.iconMobile}
                title={item.title}
                subtitle={item.subtitle}
                actionLabel={item.actionLabel}
              />
            </React.Fragment>
          ))}
        </div>
      </>
    </PageLayout>
  );
};

export default HomeScreen;
